import { render } from "./ImageGenerationView.vue?vue&type=template&id=0b4a5abc&scoped=true"
import script from "./ImageGenerationView.vue?vue&type=script&lang=js"
export * from "./ImageGenerationView.vue?vue&type=script&lang=js"

import "./ImageGenerationView.vue?vue&type=style&index=0&id=0b4a5abc&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4a5abc"]])

export default __exports__